export var TimeUnitEnum;
(function (TimeUnitEnum) {
    TimeUnitEnum["MINUTE"] = "MINUTE";
    TimeUnitEnum["SECOND"] = "SECOND";
    TimeUnitEnum["HOUR"] = "HOUR";
})(TimeUnitEnum || (TimeUnitEnum = {}));
//# sourceMappingURL=time-unit.enum.js.map